export { default, Rect } from "./Skeleton";
